<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter">Acknowledgments</h1>
<p class="nonindent">I am grateful for the dozens of professionals, parents, and children who shared their insight, expertise, and personal stories. A few of the professionals I am indebted to include Ashley Solomon, PsyD (<em><a href="http://www.nourishing-the-soul.com" target="_blank">www.nourishing-the-soul.com</a></em>); <br/>Margarita Tartakovsky, MS (<em><a href="http://blogs.psychcentral.com/weightless" target="_blank">http://blogs.psychcentral.com/weightless</a></em>); Rosie Molinary (<em><a href="http://www.rosiemolinary.com" target="_blank">www.rosiemolinary.com</a></em>), author <br/>of <em>Beautiful You: A Daily Guide to Radical Self-Acceptance</em> and <em>Hijas Americanas: Beauty, Body Image, and Growing Up Latina</em>; Diane Keddy, MS, RD, FAED (<em><a href="http://www.dianekeddy.com" target="_blank">www.dianekeddy.com</a></em>); <br/>Katja Rowell, MD (<em><a href="http://www.familyfeedingdynamics.com" target="_blank">www.familyfeedingdynamics.com</a></em>); and <br/>Laura Stern (<em><a href="http://www.laurenlazarstern.com" target="_blank">www.laurenlazarstern.com</a></em>), author of <em>The Slender Trap: A Food and Body Workbook</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?54ff2172